import { Product } from '@/type';
import { map } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatCurrency } from '@/service';
import { Link } from 'react-router-dom';
import DataCenter from '@/modules/data/DataCenter';

type ProductItemComponentProps = {
  product: Product;
  language: string;
  onClick?: (it: Product) => void;
  enable?: boolean;
  selected?: boolean;
};
export const ProductItemComponent = ({
  product,
  language,
  onClick,
  enable,
  selected,
}: ProductItemComponentProps) => {
  const getInfo = (language: string, product: Product) => {
    if (language.startsWith(DataCenter.SUPPORT_LANGUAGE.en.language, 0)) {
      return {
        name: product.name_en,
        description: product.description_en,
      };
    } else if (
      language.startsWith(DataCenter.SUPPORT_LANGUAGE.zh.language, 0)
    ) {
      return {
        name: product.name_zn,
        description: product.description_zn,
      };
    }
    return {
      name: product.name_de,
      description: product.description_de,
    };
  };
  const hotDegree = map(Array(product.hot_degree ?? 0), () => '🌶').join('');
  const docPath = !import.meta.env.VITE_DOCUMENT_BLOB_BACKUP
    ? product.document?.path
    : import.meta.env.VITE_DOCUMENT_BLOB_BACKUP === 'supabase'
    ? product.document?.path_supabase
    : product.document?.path_other_backup ?? '';
  return (
    <React.Fragment>
      <div>
        <img src={docPath} alt={product.document?.file_name} loading="lazy" />
        <div className="price">
          {selected && (
            <div className="alert alert-success">
              <h4>
                <label className="label label-success">
                  <FormattedMessage id="app.cart.add.ordered" />
                </label>
              </h4>
            </div>
          )}
          <span>{formatCurrency(product.price, language)}</span>
          {enable && (
            <button
              className="btn btn-primary"
              onClick={() => onClick?.(product)}
            >
              <FormattedMessage id="app.cart.add" />
              &nbsp;&nbsp;
              <Link className="fa fa-shopping-cart" to="#" />
            </button>
          )}
        </div>
      </div>
      <div>
        <h2>
          {product.reference_id}.{getInfo(language, product).name}
        </h2>
        <span>{hotDegree}</span>
        <span>{getInfo(language, product).description}</span>
        <span>{formatCurrency(product.price, language)}</span>
      </div>
    </React.Fragment>
  );
};
